import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='19' height='14' viewBox='0 0 19 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M13.3069 0.931934L18.7354 6.36038C19.0882 6.71322 19.0882 7.28683 18.7354 7.63968L13.3069 13.0681C12.9541 13.421 12.3805 13.421 12.0276 13.0681C11.6748 12.7153 11.6748 12.1417 12.0276 11.7888L15.9108 7.90567H0.90474C0.405324 7.90567 0 7.50035 0 7.00093C0 6.50152 0.405324 6.09619 0.90474 6.09619H15.9108L12.0276 2.21305C11.8503 2.03572 11.7634 1.8041 11.7634 1.57249C11.7634 1.34088 11.8521 1.10926 12.0276 0.931934C12.3805 0.579085 12.9541 0.579085 13.3069 0.931934Z'
      fill='#0D0D0D'
    />
  </svg>
)
